module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Bottmingen-801d0b12589210f2cc69ef204071d1d3.svg";